import { observer } from 'mobx-react-lite';
import React from 'react';
import FilterIcon from '../FilterIcon';
import * as styles from '../Filter/Filter.scss';
import strings from '../../strings';

const ConfirmedContactsIcon = ({ confirmedContacts, handleConfirmedContactsClick }) => {
  const confirmedContactsImgUrlDefault = '/rating/assets/images/confirmedContacts/default.svg';
  const confirmedContactsImgUrlSelected = '/rating/assets/images/confirmedContacts/selected.svg';

  const confirmedContactsIcon = (
    <img
      alt="confirmed-contacts"
      className={styles.confirmedContacts}
      src={confirmedContactsImgUrlDefault}
    />
  );

  const confirmedContactsIconSelected = (
    <img
      alt="confirmed-contacts"
      className={styles.confirmedContacts}
      src={confirmedContactsImgUrlSelected}
    />
  );

  const confirmedContactsText = strings.confirmedContacts;

  return (
    <FilterIcon
      icon={confirmedContactsIcon}
      iconSelected={confirmedContactsIconSelected}
      text={confirmedContactsText}
      pressed={confirmedContacts}
      handleClick={handleConfirmedContactsClick}
    />
  );
};

export default observer(ConfirmedContactsIcon);
